import { PatientsApi } from 'integration/api/patients';

/**
 * Custom hook to download a CSV template.
 *
 * @returns A function that when called, will initiate the process of downloading the CSV template.
 */
export const useDownloadCSVTemplate = () => {
  /**
   * Function to initiate the process of downloading the CSV template.
   */
  const downloadDocument = async () => {
    try {
      const response = await PatientsApi.downloadCSVTemplate();

      // Extract the filename from the Content-Disposition header if present
      const contentDisposition = response?.headers['content-disposition'];
      let fileName = 'downloaded_file';
      if (contentDisposition) {
        const matches = /filename="([^"]+)"/.exec(contentDisposition);
        if (matches && matches[1]) {
          fileName = matches[1];
        }
      }

      // Create a Blob from the response data and generate a download URL
      const downloadUrl = window.URL.createObjectURL(
        new Blob([response?.data]),
      );

      // Create an anchor element, set its href attribute to the download URL, and initiate the download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e) {
      console.log('Download document error: ', e);
    }
  };

  return downloadDocument;
};
